import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ProjectPublicResponse } from '@app/models/project.models';
import { ProjectService } from '@app/services/projects/service';
import { ModalComponent } from '@app/ui-components/modal/modal.component';
import { ValidatedCheckboxComponent } from '@app/ui-components/validated-checkbox/validated-checkbox.component';
import { ValidatedCurrencyInputComponent } from '@app/ui-components/validated-currency-input/validated-currency-input.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { CurrencyFormatPipe } from '../../../+pipes/currency-format.pipe';

@Component({
  selector: 'app-invest-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ModalComponent,
    ReactiveFormsModule,
    TranslatePipe,
    ValidatedCurrencyInputComponent,
    CurrencyFormatPipe,
    ValidatedCheckboxComponent,
  ],
  templateUrl: './invest-dialog.component.html',
  styleUrl: './invest-dialog.component.scss',
})
export class InvestDialogComponent {
  private _projectDetails?: ProjectPublicResponse;
  private projectService = inject(ProjectService);

  @Input({ required: true })
  set projectDetails(value: ProjectPublicResponse | undefined) {
    this._projectDetails = value;
    this.minAmount = value?.offerMinAmount ?? 0;
    this.maxAmount = value?.offerMaxAmount ?? 0;
    const amountControl = this.investForm.controls.amount;
    amountControl.setValidators([
      Validators.required,
      Validators.min(this.minAmount),
      Validators.max(this.maxAmount),
    ]);
    amountControl.updateValueAndValidity({
      emitEvent: false,
    });
  }

  get projectDetails(): ProjectPublicResponse | undefined {
    return this._projectDetails;
  }

  private fb = inject(FormBuilder);
  protected minAmount: number = 0;
  protected maxAmount: number = 0;
  @Input() investmentProtection = true;
  protected investForm = this.fb.nonNullable.group({
    amount: [
      0,
      [
        Validators.required,
        Validators.min(this.minAmount),
        Validators.max(this.maxAmount),
      ],
    ],
    consent: [false, Validators.requiredTrue],
  });

  constructor(public activeModal: NgbActiveModal) {}

  applyInvestment() {
    this.investForm.markAllAsTouched();
    if (this.investForm.invalid) {
      return;
    }

    this.projectService
      .invest(
        this.projectDetails?.id ?? '',
        this.investForm.controls.amount.value,
        this.investmentProtection,
      )
      .subscribe(() => {
        this.activeModal.close('success');
      });
  }
}
